import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./PricingTable.scss";

const PricingTable = ({ data}) => {

  const [plans, setPlans] = useState([]);

  useEffect(() => {
    // serverInstance.get("/app/plans")
    //   .then((res) => {
    //     if (res.status === 200) {
    //       setPlans(res.data.items);
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   })
    
    // window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pricing-table">
      <div className="title">
        <h2>{data.title}</h2>
      </div>
      <div className="plans">
        {plans.map((plan, index) => (
          <div key={index} className={`plan ` + plan.type}>
            <div className="type">{data.person} </div>
            <div className="price">
              {new Intl.NumberFormat('mn-MN', { style: 'decimal', maximumFractionDigits: 0 }).format(plan.price)} ₮
            </div>
            <div className="term">{plan.term === 100 ? data.lifeLong : plan.term + " " + data.year}</div>
            <div className="benefits">
              <div className="benefit-title">{data.featureTitle}:</div>
              {data.features?.map((benefit, index) => (
                <div key={index} className="benefit">
                  <i className="fa fa-check"></i>
                  <span>{benefit}</span>
                </div>
              ))}
              <Link className="choose" to={"/sponsor/payment/" + plan.id}>{data.choose}</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PricingTable;
